import React, {useContext, useState} from "react";
import CustomerDataContext from "../context/CustomerDataContext";

function useCustomer(){
    const context = useContext(CustomerDataContext);
    if(!context){
        throw new Error(`useCustomer must be used within a userProvider`);
    }

    return context;
}

const CustomerProvider = (props) => {

    const setCustomer = (customer) => {
        setState({...state, customer: customer, loadingCustomer: false})
    }

    const setLoading = (loading) => {
        setState({...state, loadingCustomer: loading})
    }

    const [state,setState] = useState(
        {
            customer: null,
            setCustomer: setCustomer,
            loadingCustomer: false,
            setLoading: setLoading
        }
    );

    return(
        <CustomerDataContext.Provider value={state}>
            {props.children}
        </CustomerDataContext.Provider>
    )
}

export  {CustomerProvider, useCustomer};